import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    container: {
        marginTop: '25px',
        background: 'white',
        boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.15)',
        borderRadius: '8px',
        padding: '10px 27px 20px 27px',
    },

    tituloSeccion: {
        fontSize: '14px',
        lineHeight: '26px',
        color: '#011328',
    },

    filaInputs: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        marginTop: '10px',
        flexFlow: 'row wrap',
    },

    tipoPrestacion: {
        width: '225px',
        marginRight: '20px',
        marginTop: '10px'
    },

    tipoComprobante: {
        width: '220px',
        marginRight: '20px',
        marginTop: '10px'
    },

    codComprobante: {
        width: '230px',
        marginRight: '20px',
        marginTop: '10px'
    },

    nroComprobante: {
        width: '225px',
        marginRight: '20px',
        marginTop: '10px'
    },
    
    nroReferencia: {
        width: '225px',
        marginRight: '20px',
        marginTop: '10px'
    },

    fechaEmision: {
        width: 225,
        marginTop: 10
    },

    containerTitulo: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },

    ayuda: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: '7px',
        fontWeight: 'bold',
        fontSize: '10px',
        lineHeight: '9px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        background: '#727A94',
        color: 'white',
    },

    dropDownIcon: {
        color: '#BDBDBD',
        margin: '5px',
    },

    outlinedInput: {
        "& fieldset": {
            borderColor: "#02599E !important"
        }
    },
    iconoClearEstado: {
        margin: '7px',
    },
});
